import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=dc43a47c&scoped=true"
import script from "./user-card.vue?vue&type=script&lang=ts"
export * from "./user-card.vue?vue&type=script&lang=ts"
import style0 from "./user-card.vue?vue&type=style&index=0&id=dc43a47c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc43a47c",
  null
  
)

export default component.exports